export default "__VITE_ASSET__lcFzZPO5__"